import { useMemo } from 'react';
import { useSession } from '@sdk/session/SessionContext';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { GroupHeadersDefinition } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.types';
import { DEFAULT_GROUP_HEADERS } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.consts';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';

import { getMembersFieldPersonas } from './conversationMembersField.utils';

export const useConversationMembersField = (extraPickerOptions: PersonaPickerOption[] = []) => {
  const { personasDict } = usePersonaCollection();
  const { currentUser } = useSession();
  const nonDeletableIds = [currentUser.id];

  const groupHeadersDefinition: GroupHeadersDefinition = {
    ...DEFAULT_GROUP_HEADERS,
    everyone: {
      ...DEFAULT_GROUP_HEADERS.everyone,
      title: currentUser.org.name,
    },
  };

  const options: PersonaPickerOption[] = useMemo(() => {
    const members = getMembersFieldPersonas(currentUser, personasDict);
    return members.concat(extraPickerOptions);
  }, [personasDict, currentUser, extraPickerOptions]);

  return {
    groupHeadersDefinition,
    options,
    nonDeletableIds,
  };
};
